import './scss/index.scss';
import 'owl.carousel';
import { dcFactory } from 'dc';
import TestimonialSliderComponent from './js/testimonial-slider.component';

dcFactory.register(TestimonialSliderComponent);
